var render = function render(_c,_vm){return _c('section',{staticClass:"callout"},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_c('div',{staticClass:"default"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }